import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { Icon } from '../icon';
import { useWindowSize } from '../../hooks/window-size';
import { AnimationOnTop } from '../animation';
import { makeErrorIcon, makeNotification, makeSuccesIconNotification } from './mixins';
var ErrorIcon = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeErrorIcon();
});
var SuccesIconNotification = styled(Icon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeSuccesIconNotification();
});
var Notification = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeNotification(props);
});
export var Snackbar = function Snackbar(_ref) {
  var visible = _ref.visible,
      snackbaroptions = _ref.snackbaroptions,
      children = _ref.children;

  var _useWindowSize = useWindowSize(),
      isMobile = _useWindowSize.isMobile;

  var _Object$assign = Object.assign({}, snackbaroptions),
      _Object$assign$type = _Object$assign.type,
      type = _Object$assign$type === void 0 ? 'notificarion' : _Object$assign$type,
      icon = _Object$assign.icon,
      timer = _Object$assign.timer,
      animation = _Object$assign.animation;

  return ReactDOM.createPortal(React.createElement(Transition, {
    in: visible,
    onEntering: visible && timer,
    mountOnEnter: true
  }, function (state) {
    return (// state change: exited -> entering -> entered -> exiting -> exited
      React.createElement(AnimationOnTop, {
        name: animation,
        className: "animation-".concat(state)
      }, React.createElement(Notification, {
        width: isMobile && window.innerWidth - 32,
        type: type
      }, type === 'error' && React.createElement(ErrorIcon, null, React.createElement(Icon, {
        name: "icon-light-alert-triangle",
        color: "white",
        size: "24"
      })), children, icon && React.createElement(SuccesIconNotification, {
        name: icon,
        color: "white",
        size: "24"
      })))
    );
  }), document.getElementById('floating-elements'));
};